import React from "react";
import { PRODUCTS_LINKS } from "../data/links";
import { LinksSection } from "./links-section";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";

export const ProductsLinks = () => {
	const footerTexts = useTranslationsById({ mainSectionName: "footer" });
	const links = [...PRODUCTS_LINKS];

	return (
		<LinksSection
			title={footerTexts.getText({ id: "section.about", defaultText: "Acerca de" })}
			linksData={links}
		/>
	);
};
